/**
 * Created by Jerker Nord on 2023-10-20.
 */
import {Loner} from "../../../../Loner";
import {PixelFont} from "../../../../fonts/PixelFont";
import {LonerTargetButton} from "../LonerTargetButton";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {gsap} from "gsap";
import {LonerGameAssets} from "../../../../LonerGameAssets";
import {NLCText} from "@nolimitcity/slot-launcher/bin/display/NLCText";

export class LonerSelectContainer extends PIXI.Container {

    private _chooseText: NLCText;
    private _targetContainer: PIXI.Container;
    private _targetChurchButton: LonerTargetButton;
    private _targetSchoolButton: LonerTargetButton;
    private _targetOfficeButton: LonerTargetButton;
    private _cover: PIXI.Sprite;
    private _onSelectedCallback: Function;
    private _officeAttentionTL: gsap.core.Timeline;
    private _churchAttentionTL: gsap.core.Timeline;
    private _schoolAttentionTL: gsap.core.Timeline;
    private _hasClicked:boolean = false;

    constructor(selectedCallback: Function) {
        super();
        this._onSelectedCallback = selectedCallback;
        this.init();
    }

    private init(): void {
        this._cover = new PIXI.Sprite(PIXI.Texture.WHITE);
        this._cover.tint = 0x000000;
        this._cover.alpha = 0.75;
        this._cover.position.x = 20;
        this.addChild(this._cover);

        this._chooseText = new NLCText(Loner.apiPlugin.translations.translate("Choose your target"), new PIXI.TextStyle({
            align: "center",
            fontFamily: PixelFont.FAMILY,
            fontSize: 30,
            fill: 0xE0E0E0
        }));
        this._chooseText.anchor.set(0.5, 0);
        this._chooseText.position.set(400, 100);
        this.addChild(this._chooseText);

        this._targetContainer = new PIXI.Container();
        this._targetContainer.position.y = 200;
        this._targetOfficeButton = new LonerTargetButton("office", Loner.assetLoader.getTextures(LonerGameAssets.TTB_OFFICE_BUILDING_PIXELS)[0], Loner.assetLoader.getTextures(LonerGameAssets.TTB_OFFICE_BUILDING_HIGHLIGHT_PIXELS)[0], (selection: number) => this.onClicked(1));
        this._targetOfficeButton.scale.set(1.5, 1.5);
        this._targetContainer.addChild(this._targetOfficeButton);
        this._targetOfficeButton.position.x = (this._targetOfficeButton.width / 2);

        this._targetChurchButton = new LonerTargetButton("church", Loner.assetLoader.getTextures(LonerGameAssets.TTB_CHURCH_BUILDING_PIXELS)[0], Loner.assetLoader.getTextures(LonerGameAssets.TTB_CHURCH_BUILDING_HIGHLIGHT_PIXELS)[0], (selection: number) => this.onClicked(2));
        this._targetChurchButton.position.x = this._targetOfficeButton.position.x + this._targetOfficeButton.width + 70;
        this._targetChurchButton.scale.set(1.5, 1.5);
        this._targetChurchButton.position.y = (this._targetOfficeButton.height - this._targetChurchButton.height) / 2;
        this._targetContainer.addChild(this._targetChurchButton);

        this._targetSchoolButton = new LonerTargetButton("school", Loner.assetLoader.getTextures(LonerGameAssets.TTB_SCHOOL_BUILDING_PIXELS)[0], Loner.assetLoader.getTextures(LonerGameAssets.TTB_SCHOOL_BUILDING_HIGHLIGHT_PIXELS)[0], (selection: number) => this.onClicked(3));
        this._targetSchoolButton.position.x = this._targetChurchButton.position.x + this._targetChurchButton.width + 70;
        this._targetSchoolButton.scale.set(1.5, 1.5);
        this._targetSchoolButton.position.y = (this._targetOfficeButton.height - this._targetSchoolButton.height) / 2;
        this._targetContainer.addChild(this._targetSchoolButton);

        if (Loner.apiPlugin.isReplay == false) {
            this._targetOfficeButton.enable(true);
            this._targetChurchButton.enable(true);
            this._targetSchoolButton.enable(true);
        }

        this._targetContainer.position.x = 390 - (this._targetContainer.width / 2);
        this.addChild(this._targetContainer);

        this._officeAttentionTL = gsap.timeline({paused: true, repeat: -1});
        this._officeAttentionTL.add(gsap.timeline({repeat: 4}).add(gsap.to(this._targetOfficeButton.position, {
            ease: "bounce.out",
            duration: 0.1,
            y: -5
        })));
        this._officeAttentionTL.add(() => {
            this._targetOfficeButton.position.y = 0
        });
        this._officeAttentionTL.add(gsap.timeline({delay: 3}));

        this._churchAttentionTL = gsap.timeline({paused: true, repeat: -1});
        this._churchAttentionTL.add(gsap.timeline({delay: 1}));
        this._churchAttentionTL.add(gsap.timeline({repeat: 4}).add(gsap.to(this._targetChurchButton.position, {
            ease: "bounce.out",
            duration: 0.1,
            y: ((this._targetOfficeButton.height - this._targetChurchButton.height) / 2) - 5
        })));
        this._churchAttentionTL.add((): void => {
            this._targetChurchButton.position.y = (this._targetOfficeButton.height - this._targetChurchButton.height) / 2;
        });
        this._churchAttentionTL.add(gsap.timeline({delay: 2}));

        this._schoolAttentionTL = gsap.timeline({paused: true, repeat: -1});
        this._schoolAttentionTL.add(gsap.timeline({delay: 2}));
        this._schoolAttentionTL.add(gsap.timeline({repeat: 4}).add(gsap.to(this._targetSchoolButton.position, {
            ease: "bounce.out",
            duration: 0.1,
            y: ((this._targetOfficeButton.height - this._targetSchoolButton.height) / 2) - 5
        })));
        this._schoolAttentionTL.add((): void => {
            this._targetSchoolButton.position.y = (this._targetOfficeButton.height - this._targetSchoolButton.height) / 2;
        });
        this._schoolAttentionTL.add(gsap.timeline({delay: 1}));
    }

    private onClicked(selection: number): void {
        if (Loner.apiPlugin.isReplay == true || this._hasClicked == true) {
            return;
        }
        this._hasClicked = true;
        this.doClicked(selection);
    }

    private doClicked(selection: number): void {
        //1 = Office, 2 = church, 3 = school
        this.stopAllAttentions();
        this._chooseText.visible = false;
        this._cover.visible = false;
        let tempButton: LonerTargetButton;
        if (selection == 1) {
            this._targetChurchButton.visible = false;
            this._targetSchoolButton.visible = false;
            tempButton = this._targetOfficeButton;
        } else if (selection == 2) {
            this._targetSchoolButton.visible = false;
            this._targetOfficeButton.visible = false;
            tempButton = this._targetChurchButton;
        } else {
            this._targetChurchButton.visible = false;
            this._targetOfficeButton.visible = false;
            tempButton = this._targetSchoolButton;
        }
        tempButton.isSelected = true;
        this._onSelectedCallback(selection);

        const blinkSelectedTL: gsap.core.Timeline = gsap.timeline();
        for (let i: number = 0; i < 4; i++) {
            blinkSelectedTL.add(() => {
                tempButton.visible = true
            }, "+=0.1");
            blinkSelectedTL.add(() => {
                tempButton.visible = false
            }, "+=0.1");
        }
        blinkSelectedTL.add(() => {
            this._targetChurchButton.reset();
            this._targetOfficeButton.reset();
            this._targetSchoolButton.reset();
        });
    }

    public stopAllAttentions(): void {
        this._schoolAttentionTL.pause();
        this._targetSchoolButton.position.y = 0;
        this._officeAttentionTL.pause();
        this._targetOfficeButton.position.y = 0;
        this._churchAttentionTL.pause();
        this._targetChurchButton.position.y = 0;
    }

    public startAllAttentions(): void {
        this._officeAttentionTL.restart(true);
        this._schoolAttentionTL.restart(true);
        this._churchAttentionTL.restart(true);
        this._hasClicked = false;
        if (Loner.apiPlugin.isReplay) {
            gsap.timeline({delay: 1}).add(() => this.doClicked(parseInt(Loner.model.nextPlayerInteraction.selectedIndex)));
        }
    }

    public onResize(): void {
        this._cover.width = NolimitApplication.screenBounds.width;
        this._cover.height = 270;
    }

    public reset(): void {
        this._chooseText.visible = true;
        this._targetChurchButton.visible = true;
        this._targetSchoolButton.visible = true;
        this._targetOfficeButton.visible = true;
        this._cover.visible = true;
        this._officeAttentionTL.pause();
        this._schoolAttentionTL.pause();
        this._churchAttentionTL.pause();
        this._targetOfficeButton.position.y = 0;
        this._targetChurchButton.position.y = (this._targetOfficeButton.height - this._targetChurchButton.height) / 2;
        this._targetSchoolButton.position.y = (this._targetOfficeButton.height - this._targetSchoolButton.height) / 2;
    }
}